import * as React from 'react';
import { Loader } from 'types/load-data';
import {
	RootPage,
	RootPageLoadData,
	CataloguePage,
	CataloguePageLoadData,
	InstorePage,
	InstorePageLoadData,
	RulesPage,
	TintingPage,
	ConfiguratorsListingPage,
	ConfiguratorsListingPageLoadData,
	ConfiguratorsRatingLoadData,
	RoughWorkPage,
	RoughWorkPageLoadData,
} from 'pages';
import { InstoreServicesRoutes } from './instore-services-routes';

export type Route = {
	key: React.Key;
	component?: React.ComponentType<{ children?: React.ReactNode }>;
	path: string | string[];
	exact?: boolean;
	strict?: boolean;
	loadData?: Loader[];
	routes?: Route[];
};

export type RootRoute = Route & {
	routes: Route[];
};

export const routes: RootRoute[] = [
	{
		key: 'root',
		component: RootPage,
		path: '/',
		loadData: [RootPageLoadData],
		routes: [
			{
				key: 'catalogue',
				component: CataloguePage,
				path: '/uslugi/catalogue/',
				loadData: [CataloguePageLoadData],
				exact: true,
				strict: true,
			},
			{
				key: 'categories-listing',
				component: ConfiguratorsListingPage,
				path: '/uslugi/catalogue/:category',
				loadData: [ConfiguratorsListingPageLoadData, ConfiguratorsRatingLoadData],
				exact: true,
				strict: false,
			},
			{
				key: 'tinting',
				component: TintingPage,
				path: '/uslugi/kak-zakazat-besplatnuyu-kolerovku-onlayn/',
				exact: true,
				strict: true,
			},
			{
				key: 'instore',
				component: InstorePage,
				path: [
					'/uslugi/uslugi-v-magazinah/',
					'/uslugi/uslugi-v-magazinah/:shop',
					...InstoreServicesRoutes,
				],
				loadData: [InstorePageLoadData],
				exact: true,
				strict: false,
			},
			{
				key: 'rules',
				component: RulesPage,
				path: ['/pravila/uslugi/', '/pravila/uslugi/:type'],
				exact: true,
				strict: false,
			},
			{
				key: 'rough-work',
				component: RoughWorkPage,
				path: '/uslugi/chernovoy-remont/',
				exact: true,
				strict: true,
				loadData: [RoughWorkPageLoadData],
			},
		],
	},
];
